import router from '../../router'
import Login from './Login.vue'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/login',
      name: 'login',
      components: {
          default: Login,
        }
    }
  ])
}
